module.exports = __webpack_public_path__ + "static/media/Coronavirus.4c243933.png";